import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';
import { OrderSearchModel } from '../order/orderSearch';
export class TyreChangeOrderSearchModel extends OrderSearchModel {

  constructor() {
    super();

  }

}
